import { useEffect, useState } from "react";
import { Gift } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

export function PaymentModeSettings() {
  const [v, setV] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/payment-mode-settings").then((r) => setV(r.data)).catch(() => {}); }, []);
  if (!v) return null;
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/admin/payment-mode-settings", v); setV(data); toast.success("Payment option settings saved"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const num = (k, label, suffix, step = 1) => (
    <label className="text-xs font-semibold text-slate-700">{label}
      <div className="relative mt-1"><input type="number" min="0" step={step} className="input py-2 pr-14" value={v[k]} onChange={(e) => setV({ ...v, [k]: e.target.value })} data-testid={`pm-settings-${k}`} />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 text-xs">{suffix}</span></div></label>);
  return (
    <section className="card p-5" data-testid="pm-settings">
      <h2 className="font-bold flex items-center gap-2"><Gift size={17} className="text-[#FF8166]" />Payment options &amp; switch reward</h2>
      <p className="text-sm muted mt-1">Fees for pros who take payments directly, and the one-off credits they get for switching to MyHomelyHub payments.</p>
      <div className="grid sm:grid-cols-3 gap-3 mt-4">
        {num("uplift", "Direct-payments uplift", "%", 0.5)}
        {num("reward_credits", "Switch reward", "credits")}
        {num("reward_days", "Days on direct before reward", "days")}
      </div>
      <label className="flex items-center gap-2 text-sm mt-4"><input type="checkbox" checked={!!v.reward_enabled} onChange={(e) => setV({ ...v, reward_enabled: e.target.checked })} data-testid="pm-settings-reward_enabled" />Give the switch reward</label>
      <p className="text-xs muted mt-2">A new uplift applies to new purchases straight away. Existing subscriptions keep their price until the pro next changes payment option.</p>
      <button disabled={busy} onClick={save} className="btn-coral btn-sm mt-3" data-testid="pm-settings-save">{busy ? "Saving..." : "Save settings"}</button>
    </section>
  );
}
